import { render, staticRenderFns } from "./ExpansionCardUser.vue?vue&type=template&id=8117ab4a"
import script from "./ExpansionCardUser.vue?vue&type=script&lang=js"
export * from "./ExpansionCardUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports